import { useHistory } from 'react-router-dom';
import { Button } from 'components';
import AddIcon from '@mui/icons-material/Add';

type AddButtonProps = {
  path: string;
  title?: string;
};

export const AddButton = ({
  path,
  title = 'cadastrar novo',
}: AddButtonProps) => {
  let history = useHistory();

  const handleClick = () => {
    history.push(path);
  };

  return (
    <Button
      startIcon={<AddIcon />}
      size="large"
      onClick={handleClick}
      sx={{ color: '#FFFFFF' }}
    >
      {title}
    </Button>
  );
};

